module.exports = __webpack_public_path__ + "20230117/img/slide1_btn.df32a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1_btn.png
// module id = cxRn
// module chunks = 1